<template>
    <div v-show="!showMyLoading" class="container order-confirm">
        <l-card type="primary" plaintext l-class="card" l-title-class="card-title" title="商品">
            <div v-if="productsArr" class="goods-container">
                <div v-for="item in productsArr" :key="item.id" class="goods-item">
                    <div class="product-info">
                        <v-a id-type="confirmProduct" catch:tap="onProduct" data-id="item.id">
                            <img class="goods-img" :src="item.thumb_img" mode="widthFix" />
                        </v-a>
                        <div class="right">
                            <v-a id-type="confirmProduct" catch:tap="onProduct" data-id="item.id">
                                <div class="text">{{item.name}}</div>
                            </v-a>
                            <div class="spec-container">
                                <!-- <div class="spec" >
                                <div class="label">颜色:</div>
                                <l-tag class="tag" size="mini" plain font-color="red">白色</l-tag>
                                </div>-->
                                <span class="spec-text">{{item.key_name}}</span>
                            </div>
                            <div class="price-num">
                                <l-price
                                    l-class="price"
                                    unit="￥"
                                    :count="item.shop_price"
                                    :unit-color="themeColor"
                                    :count-color="themeColor"
                                    :unit-size="11"
                                    :count-size="14"
                                    :count-blod="true"
                                    unit-blod
                                    :delete="false"
                                    del-color
                                />
                                <l-price
                                    l-class="price"
                                    unit="x"
                                    :count="item.count"
                                    unit-color="#000"
                                    count-color="#000"
                                    :unit-size="11"
                                    :count-size="14"
                                    :count-blod="true"
                                    unit-blod
                                    :delete="false"
                                    del-color
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </l-card>

        <l-card type="primary" plaintext l-class="card" l-title-class="card-title" title="付款方式">
            <div class="pay-way">
                <van-radio-group v-model="payWay" bind:linchange="onChange" l-class="l-radio-group">
                    <van-radio
                        custom="true"
                        class="l-radio"
                        l-title-class="l-title-class"
                        placement="left"
                        shape="round"
                        :disabled="false"
                        name="wechat"
                        :checked-color="themeColor"
                    >
                        <div slot="default" class="pay-desc">
                            <span>微信支付</span>
                        </div>
                    </van-radio>
                </van-radio-group>
            </div>
        </l-card>
        <l-card type="primary" plaintext l-class="card" l-title-class="card-title" title="买家留言">
            <div class="buyer-msg">
                <textarea
                    v-model="buyerMsg"
                    class="textarea-msg"
                    auto-height="true"
                    maxlength="255"
                    rows="4"
                    placeholder="选填，请先和商家协商一致"
                    bind:linblur="changeBuyerMsg"
                ></textarea>
            </div>
        </l-card>

        <div class="bottom">
            <div></div>
            <div class="total-btn">
                <div class="total">
                    <span>合计</span>
                    <l-price
                        l-class="price"
                        unit="￥"
                        :count="account"
                        :unit-color="themeColor"
                        :count-color="themeColor"
                        :unit-size="9"
                        :count-size="16"
                        :count-blod="true"
                        unit-blod
                        :delete="false"
                        del-color
                    />
                </div>

                <l-button shape="spuare" class="submit" @lintap="pay">提交订单</l-button>
            </div>
        </div>
        <Loading :show="showMyLoading" loadingtext="拼命加载中..." />
    </div>
</template>

<script>
import Loading from '../components/my/Loading.vue'
import CardVue from '../components/lin-ui/Card.vue'
import AVue from '../components/my/A.vue'
import PriceVue from '../components/lin-ui/Price.vue'
import { CommonMixins } from '../components/mixins'
import { GoodsModel } from '../models/goods'
import { Cart } from '../models/cart'
import { OrderModel } from '../models/order'
import { add, div, is_undefined } from '../utils/cal'
import ButtonVue from '../components/lin-ui/Button.vue'
import { Toast } from 'vant'
const goods = new GoodsModel()
const cart = new Cart()
const order = new OrderModel()

export default {
    name: 'OrderConfirm',
    components: {
        Loading,
        'l-card': CardVue,
        'v-a': AVue,
        'l-price': PriceVue,
        'l-button': ButtonVue
    },
    mixins: [CommonMixins],
    data() {
        return {
            shippingWays: [
                {
                    id: 1,
                    name: '发送物流'
                },
                {
                    id: 2,
                    name: '上门自提'
                }
            ],
            account: 0,
            address: null,
            shippingWay: '发送物流',
            payWay: 'wechat',
            buyerMsg: '',
            productsArr: null,
            orderStatus: 0,
            payStatus: 0,
            buy_now: 0,
            spec_key: '',
            count: 1,
            id: 0
        }
    },
    computed: {},
    created() {},
    mounted() {
        this.isBuyNow()
        this._loadData()
        this.myLoading(0)
    },
    methods: {
        isBuyNow() {
            let param = this.$route.query
            let buy_now = param.buy_now ? param.buy_now : 0
            if (buy_now == 1) {
                const { spec_key, count, id } = param
                this.setData({
                    buy_now,
                    spec_key,
                    count,
                    id
                })
            }
        },
        _loadData() {
            this.getCartGoods()
        },
        async getCartGoods() {
            const { buy_now, spec_key, count, id } = this.$data
            let productsArr
            if (buy_now) {
                productsArr = await goods.getBuyNowData(id, spec_key, count)
            } else {
                productsArr = await cart.getCartDataFromLocal(true)
            }

            this.setData({
                productsArr
            })
            this.calTotalMoney()
        },
        calTotalMoney() {
            const data = this.productsArr
            let account = 0
            for (var i in data) {
                var price = data[i].shop_price * 100,
                    money = price * data[i].count
                account = add(account, money)
            }
            this.setData({
                account: div(account, 100)
            })
        },
        changeBuyerMsg(e) {
            this.setData({
                buyerMsg: e.detail.detail.value
            })
        },
        pay(e) {
            if (!this.productsArr) {
                Toast('亲，下单前请选商品~~')
                return
            }
            // 支付过则无效
            var orderStatus = this.orderStatus,
                payStatus = this.payStatus
            if (payStatus == 1) return
            if (orderStatus == 0) {
                this._firstTimePay()
            } else {
                this._oneMoresTimePay()
            }
        },
        // 第一次支付
        _firstTimePay: function() {
            this.myLoading(0)
            const oProducts = order.getProductsParameter(this.productsArr)
            const oParam = order.getOrderPriceNeedParameter(
                this.$data,
                oProducts
            )
            // 生成订单
            order.doOrder(oParam).then(
                aOrderStatus => {
                    this.myLoading(0)
                    if (aOrderStatus.pass) {
                        const id = aOrderStatus.order_id
                        this.id = id
                        this.fromCartFlag = false
                        this._execPay(id)
                    } else {
                        // this._orderFail(aOrderStatus)
                        console.log(aOrderStatus)
                    }
                },
                err => {
                    console.log(err)
                    this.myLoading(0)
                }
            )
        },
        // 再支付或者订单发起支付
        _oneMoresTimePay: function() {
            this._execPay(this.id)
        },

        _execPay: function(id) {
            if (this.payWay == 'wechat') {
                order
                    .getPreOrder(id)
                    .then(res => {
                        this.callpay(res)
                        return
                        if (nStatus != 0) {
                            !this.buy_now && this.deleteProducts()
                            const flag = nStatus == 2
                            this.dialog(
                                '支付结果',
                                flag ? '成功' : '失败'
                            ).then(res => {
                                return promisify(wx.redirectTo)({
                                    url: `/pages/order/detail/detail?id=${id}`
                                }).then(() => {})
                            })
                        }
                    })
                    .catch(e => {
                        console.log(e)
                    })
            } else {
                // pass to do 其他处理
            }
        },
        // 清空购物车
        deleteProducts: function() {
            var productsArr = this.productsArr,
                aPids = [],
                aSpecKeys = []
            for (var i = 0; i < productsArr.length; i++) {
                aPids.push(productsArr[i].id)
                aSpecKeys.push(productsArr[i].spec_key)
            }
            cart.delete(aPids, aSpecKeys)
        },
        jsApiCall(params) {
            WeixinJSBridge.invoke('getBrandWCPayRequest', params, function(
                res
            ) {
                console.log(333, res)
            })
        },

        callpay(params) {
            if (typeof WeixinJSBridge == 'undefined') {
                if (document.addEventListener) {
                    document.addEventListener(
                        'WeixinJSBridgeReady',
                        this.jsApiCall(params),
                        false
                    )
                } else if (document.attachEvent) {
                    document.attachEvent(
                        'WeixinJSBridgeReady',
                        this.jsApiCall(params)
                    )
                    document.attachEvent(
                        'onWeixinJSBridgeReady',
                        this.jsApiCall(params)
                    )
                }
            } else {
                this.jsApiCall(params)
            }
        }
    }
}
</script>
<style lang='stylus'>
.order-confirm
    padding-top: 10px
    padding-bottom: 40px
    .card
        margin-top: 15px
    .address-container
        padding-bottom: 16px
        background-size: 64px 5px
        display: flex
        align-items: center
    .name-mobile
        display: flex
        justify-content: space-between
        margin: 5px 0
    .goods-item
        margin-bottom: 10px
        .product-info
            display: flex
            .goods-img
                width: 60px
                margin-right: 5px
                border-radius: 2px
            .right
                flex: 1
            .spec
                width: auto
                display: inline-flex
                align-items: center
                l-tag
                    margin: 7.5px
            .spec-text
                color: #A2A2A2
            .price-num
                // margin-top: 20rpx;
                display: flex
                justify-content: space-between
    .pay-desc
        display: flex
    .bottom
        position: fixed
        bottom: 0
        width: 100%
        display: flex
        align-items: center
        justify-content: space-between
        background: #fff
        padding-left: 15px
        z-index: 3
        .total-btn
            display: flex
            .total
                display: flex
                align-items: center
.total-btn
    min-width: 180px
    justify-content: space-between
.price
    margin-top: 3px
.l-radio
    margin: 5px 0
.textarea-msg
    margin-top: 5px
    width: 100% !important
.textarea-msg
    border: 1px solid #e3e3e3
    padding: 5px
    box-sizing: border-box
.card
    padding: 5px 15px 7.5px !important
.card-title
    margin-bottom: 5px
.l-card-address
    padding: 5px 15px 7.5px 15px !important
.l-button-address-more
    border: none !important
    min-width: 25px !important
    padding: 0 !important
.l-button-address-add
    border: none !important
    width: 100% !important
    justify-content: flex-start !important
</style>
